import React from 'react'
// Import Section Heading
import SectionHeading from '../../Home/SectionHeading/SectionHeading'
import '../../../assets/css/style.css'
// Import TeamData
import {TeamData} from './TeamData'

// Import TeamCard
import TeamCard from './TeamCard'

const TeamMembers = ({className=""}) => {

    return (
        <>
            {/* Team Area Start */}
            <section id="team-area" className={`py100 ${className}`}>
                <div className="container">
                    <SectionHeading title="Our Team" heading=""/>
                    <div className="teaminfo row">
                        {TeamData.map((data, index) => (<TeamCard data={data} key={index}/>))}
                    </div>
                </div>
            </section>
            {/* Team Area End */}
        </>
    )
}

export default TeamMembers
